import { useSelector } from 'react-redux'

import { AppId } from 'clickNgo/configs/app'
import { ProfilingRequestSource } from 'clickNgo/configs/profiling/common'
import { getUrlParam } from 'core-components/helpers/url'
import { selectAppId } from 'core-components/sitebuilder/store/selectors/selectAppId'

export function useAppSource(defaultSource?: string) {
  const appId = useSelector(selectAppId)
  const page: string = getUrlParam('page')
  const clickAndGoPages = ['newpartners', 'partner-dashboard']
  const p360Pages = ['jbl-hpscoutso']

  const isLutApp = appId === AppId.Lut

  switch (true) {
    case isLutApp:
      return ProfilingRequestSource.Lut
    case page && clickAndGoPages.some((el) => page.includes(el)):
      return ProfilingRequestSource.ClickAndGo
    case page && p360Pages.some((el) => page.includes(el)):
      return ProfilingRequestSource.P360
    default:
      return defaultSource || ProfilingRequestSource.ClickAndGo
  }
}
